export { default as lazyLoader } from './component'
